import {Typography} from '@mui/material';
import {CompleteProfileEnum} from 'main/analytics/gaTagsEnum';
import {AlertActions, AlertModal} from 'presentation/components';
import {HomeEnum, ProfileEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {AlertProps} from './types';

const {headerTitle, title, description, primaryAction, secondaryAction} =
	translations['pt-br'].privateFlow.bookingFlow.confirmationDrawer.alert;

const Alert = ({message, open, handleClose, handleCallback}: AlertProps) => {
	const navigate = useNavigate();
	const {pathname} = useLocation();

	const handlePrimaryAction = () => {
		handleCallback?.();
		handleClose();
		navigate(ProfileEnum.PROFILE, {state: pathname});
	};

	const handleSecondaryAction = () => {
		handleCallback?.();
		handleClose();
		navigate(HomeEnum.HOME_PAGE, {state: pathname});
	};

	return (
		<AlertModal
			data-tag-id={CompleteProfileEnum.DV_VISUALIZOU_MODAL_AVISO}
			sx={{zIndex: 9999}}
			footerContent={
				<AlertActions
					flexDirection="column-reverse"
					primaryText={primaryAction}
					secondaryText={secondaryAction}
					primaryAction={handlePrimaryAction}
					secondaryAction={handleSecondaryAction}
					dataTagId={CompleteProfileEnum.DV_CLICK_IR_PARA_PERFIL}
					secondaryBtnDataTagId={CompleteProfileEnum.DV_CLICK_VOLTAR_PARA_INICIO}
				/>
			}
			subDescription={
				<Typography component="span" textAlign="center">
					{message}
					<br />
					{description}
				</Typography>
			}
			headerTitle={headerTitle}
			title={title}
			open={open}
			variant="info"
			disableClose
		/>
	);
};

export {Alert};
